module.exports = __webpack_public_path__ + "img/ring_r_i_1_0@2x.6761bd68.png";